/** @jsx jsx */
import { jsx } from '@emotion/react';

import type { DotLottieReactProps } from '@lottiefiles/dotlottie-react';
import * as Sentry from '@sentry/react';

import createLoadableComponent from 'js/lib/createLoadableComponent';

// Taken from Lottie package source code: https://github.com/LottieFiles/dotlottie-web/blob/772c1e160c608ab1eb63dde3fea9f8c07be5ed03/packages/web/src/core/dotlottie-wasm-loader.ts#L12
export const LOTTIE_WASM_URL =
  'https://cdn.jsdelivr.net/npm/@lottiefiles/dotlottie-web@0.44.0/dist/dotlottie-player.wasm';
let isInitialized = false;

// Lazy-loaded DotLottieReact using createLoadableComponent
const DotLottieReactWrapper = createLoadableComponent(async () => {
  const { DotLottieReact, setWasmUrl } = await import('@lottiefiles/dotlottie-react');

  // Set WASM URL once globally on first import
  if (!isInitialized) {
    try {
      setWasmUrl(LOTTIE_WASM_URL);
      isInitialized = true;
    } catch (error) {
      Sentry.captureException(error, {
        tags: { component: 'DotLottieReact' },
        extra: { wasmUrl: LOTTIE_WASM_URL },
      });
    }
  }

  const DotLottieReactCore = (props: DotLottieReactProps) => {
    return <DotLottieReact {...props} />;
  };

  return { default: DotLottieReactCore };
});

export default DotLottieReactWrapper;
